import React from "react";

export default function OptionsPositionSymbolCell({ symbolDisplay, sideAccent = "#848e9c" }) {
  if (!symbolDisplay) return "—";

  return (
    <div
      className="agcex-opt-pos-symbol"
      style={{ "--agcex-opt-pos-accent": sideAccent }}
    >
      <div className="agcex-opt-pos-symbol__primary">{symbolDisplay.primary || "—"}</div>
      <div className="agcex-opt-pos-symbol__secondary">{symbolDisplay.secondary || "—"}</div>
    </div>
  );
}
